// @ts-nocheck
import { isInsuranceActive, typeDateToTimestamp } from '@/misc/utils/insuranceUtils'

const sort = {
  methods: {
    sortByDateInsurances(array) {
      return array.sort(function (a, b) {
        const aIsNewItem = a.isNewItem ? 1 : 0
        const bIsNewItem = b.isNewItem ? 1 : 0
        const newItemCompare = aIsNewItem - bIsNewItem
        if (newItemCompare !== 0) {
          return newItemCompare
        }

        const aActive = isInsuranceActive(a) ? 0 : 1
        const bActive = isInsuranceActive(b) ? 0 : 1
        const activeCompare = aActive - bActive
        if (activeCompare !== 0) {
          return activeCompare
        }

        const aStartDate = typeDateToTimestamp(a.startDate)
        const bStartDate = typeDateToTimestamp(b.startDate)
        return (bStartDate === null) - (aStartDate === null) || bStartDate - aStartDate
      })
    },
    sortByDateMortgages(array) {
      const that = this
      return array.sort(function (a, b) {
        const aStartDate = a.validFrom && a.validFrom.year && a.validFrom.year !== -1 ? new Date(a.validFrom.year + '-' + ('0' + a.validFrom.month).slice(-2) + '-' + ('0' + a.validFrom.day).slice(-2)).getTime() : null
        const aEndDate = a.expiresAt && a.expiresAt.year && a.expiresAt.year !== -1 ? new Date(a.expiresAt.year + '-' + ('0' + a.expiresAt.month).slice(-2) + '-' + ('0' + a.expiresAt.day).slice(-2)).getTime() : null
        const aIsNewItem = a.isNewItem ? 1 : 0
        const bStartDate = b.validFrom && b.validFrom.year && b.validFrom.year !== -1 ? new Date(b.validFrom.year + '-' + ('0' + b.validFrom.month).slice(-2) + '-' + ('0' + b.validFrom.day).slice(-2)).getTime() : null
        const bEndDate = b.expiresAt && b.expiresAt.year && b.expiresAt.year !== -1 ? new Date(b.expiresAt.year + '-' + ('0' + b.expiresAt.month).slice(-2) + '-' + ('0' + b.expiresAt.day).slice(-2)).getTime() : null
        const bIsNewItem = b.isNewItem ? 1 : 0
        return that.sortByDate(aStartDate, aEndDate, bStartDate, bEndDate, aIsNewItem, bIsNewItem)
      })
    },
    sortByDate(aStart, aEnd, bStart, bEnd, aIsNewItem, bIsNewItem) {
      return aIsNewItem - bIsNewItem || (bStart === null) - (aStart === null) || (bEnd === null) - (aEnd === null) || bEnd - aEnd || bStart - aStart
    }
  }
}

export { sort }
